<template>
  <div class="detail_container">
    <v-container class="scheme_node_elements">
      <v-data-table
        :calculate-widths="true"
        :headers="headers"
        :items="$store.state.SchemeNodeElementsModule.listEntries"
        :loading="$store.state.SchemeNodeElementsModule.loadingList"
        :items-per-page="-1"
        class="elevation-1 scheme_node_elements__table"
        hide-default-footer
        loading-text="Загрузка..."
        sort-by="name_ru"
        @click:row="editItem"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title class="scheme_node_elements__header"
              >Легенда узлов отопления — элементы</v-toolbar-title
            >
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="600">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  dark
                  class="mb-2"
                  v-bind="attrs"
                  v-on="on"
                  @click="addNewEntry"
                >
                  Добавить
                </v-btn>
              </template>
              <v-card>
                <v-card-title class="text-h6 d-block text-center">{{
                  formTitle
                }}</v-card-title>
                <v-card-text class="scheme_node_elements__modal_item">
                  <!-- Иконка элемента (SVG): только для админки — список, превью в карточке узла, если символа нет в SVG узла -->
                  <div class="scheme_node_elements__icon_block">
                    <div
                      v-if="editedItem._file && editedItem._file.full_path"
                      class="scheme_node_elements__preview"
                    >
                      <img :src="editedItem._file.full_path" :alt="editedItem.name_en" />
                    </div>
                    <div class="d-flex align-center" style="column-gap: 12px">
                      <v-btn
                        small
                        outlined
                        color="primary"
                        :loading="iconUploading"
                        :disabled="$store.state.SchemeNodeElementsModule.loadingList"
                        @click="$refs.iconInput.click()"
                      >
                        <v-icon left small>mdi-upload</v-icon>
                        {{
                          editedItem._file && editedItem._file.full_path
                            ? "Заменить иконку"
                            : "Загрузить иконку (SVG)"
                        }}
                      </v-btn>
                      <span
                        v-if="!(editedItem._file && editedItem._file.full_path)"
                        class="text-caption grey--text"
                      >
                        Иконка не загружена
                      </span>
                    </div>
                    <div v-if="iconError" class="text-caption red--text mt-1">
                      {{ iconError }}
                    </div>
                    <input
                      ref="iconInput"
                      type="file"
                      accept=".svg,image/svg+xml"
                      style="display: none"
                      @change="onIconSelected"
                    />
                  </div>
                  <InputStyledSimple
                    :data="editedItem.code"
                    :is-loading="$store.state.SchemeNodeElementsModule.loadingList"
                    :is-disabled="$store.state.SchemeNodeElementsModule.loadingList"
                    placeholder="code = id символа в SVG (xlink:href без #, напр. Ball_valve)"
                    @update-input="editedItem.code = $event"
                  />
                  <InputStyledSimple
                    :data="editedItem.name_ru"
                    :is-loading="$store.state.SchemeNodeElementsModule.loadingList"
                    :is-disabled="$store.state.SchemeNodeElementsModule.loadingList"
                    placeholder="Название RU"
                    @update-input="editedItem.name_ru = $event"
                  />
                  <InputStyledSimple
                    :data="editedItem.name_en"
                    :is-loading="$store.state.SchemeNodeElementsModule.loadingList"
                    :is-disabled="$store.state.SchemeNodeElementsModule.loadingList"
                    placeholder="Название EN"
                    @update-input="editedItem.name_en = $event"
                  />
                  <InputStyledSimple
                    :data="editedItem.marking_ru"
                    :is-loading="$store.state.SchemeNodeElementsModule.loadingList"
                    :is-disabled="$store.state.SchemeNodeElementsModule.loadingList"
                    placeholder="Обозначение RU на схемах (напр. КШ → КШ-1, КШ-2 на SVG узла)"
                    @update-input="editedItem.marking_ru = $event"
                  />
                  <v-autocomplete
                    ref="family"
                    v-model="editedItem.id_family"
                    :items="familyOptions"
                    item-text="name"
                    item-value="id"
                    label="Семейство номенклатуры (обязательно)"
                    hint="Обязательно для оборудования с подбором: семейство определяет, какую номенклатуру предлагать (у КШ — только «Краны шаровые»), а его основные параметры станут списком характеристик в условиях элемента"
                    :error-messages="editedItem.id_family ? [] : ['Не задано — подбор номенклатуры для этого элемента работать не будет']"
                    persistent-hint
                    clearable
                    outlined
                    dense
                    no-data-text="Ничего не найдено"
                  />
                </v-card-text>
                <v-card-actions>
                  <v-btn color="blue darken-1" text class="mr-auto" @click="dialog = false">
                    Отмена
                  </v-btn>
                  <v-btn
                    color="blue"
                    text
                    :loading="$store.state.SchemeNodeElementsModule.loadingList"
                    :disabled="
                      !editedItem.code ||
                      !editedItem.name_ru ||
                      !editedItem.name_en ||
                      $store.state.SchemeNodeElementsModule.loadingList
                    "
                    @click="saveEntry"
                  >
                    Сохранить
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog v-model="dialogDelete" max-width="500">
              <v-card>
                <v-card-title class="text-h6 d-block text-center"
                  >Удалить элемент «{{ editedItem.name_ru }}»?</v-card-title
                >
                <v-card-actions>
                  <v-btn color="blue darken-1" text class="mr-auto" @click="dialogDelete = false">
                    Отмена
                  </v-btn>
                  <v-btn
                    color="red darken-1"
                    text
                    :loading="$store.state.SchemeNodeElementsModule.loadingList"
                    @click="deleteEntryConfirmed"
                  >
                    Удалить
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>

        <!-- справка в шапке: по какому полю элемент находится на SVG -->
        <template v-slot:header.code="{ header }">
          <span>{{ header.text }}</span>
          <v-tooltip bottom max-width="340">
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="ml-1" v-bind="attrs" v-on="on">
                mdi-information-outline
              </v-icon>
            </template>
            <span>
              По этому полю элемент сопоставляется с чертежом: code должен совпадать с id символа
              в SVG, то есть с <b>xlink:href</b> у <b>&lt;use&gt;</b> без «#» (например,
              xlink:href="#Ball_valve" → Ball_valve). Регистр не важен. Один code — один id символа.
            </span>
          </v-tooltip>
        </template>

        <template v-slot:item._family.name="{ item }">
          <span v-if="item._family && item._family.name">{{ item._family.name }}</span>
          <span v-else class="orange--text text--darken-2" title="Без семейства подбор номенклатуры для этого элемента не работает">
            <v-icon small color="orange darken-2">mdi-alert-outline</v-icon> не задано
          </span>
        </template>
        <template v-slot:item.icon="{ item }">
          <img
            v-if="item._file && item._file.full_path"
            :src="item._file.full_path"
            :alt="item.name_en"
            class="scheme_node_elements__icon"
          />
        </template>

        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click.stop="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon small @click.stop="deleteItem(item)"> mdi-delete </v-icon>
        </template>

        <template v-slot:no-data> Легенда пуста </template>
      </v-data-table>
    </v-container>
  </div>
</template>

<script>
import InputStyledSimple from "@/components/common/InputStyledSimple";
import { SchemeNodeElement } from "@/helpers/constructors";

export default {
  name: "SchemeNodeElements",
  components: { InputStyledSimple },
  data: () => ({
    headers: [
      { text: "", value: "icon", sortable: false, width: "56px" },
      { text: "code", value: "code", sortable: true, width: "14%" },
      { text: "Название RU", value: "name_ru", sortable: true, width: "20%" },
      { text: "Название EN", value: "name_en", sortable: true, width: "16%" },
      { text: "Обозначение", value: "marking_ru", sortable: true, width: "12%" },
      { text: "Семейство", value: "_family.name", sortable: true, width: "16%" },
      { text: "", value: "actions", sortable: false, width: "8%" },
    ],
    dialog: false,
    dialogDelete: false,
    editedItem: new SchemeNodeElement(),
    iconUploading: false,
    iconError: "",
  }),
  computed: {
    // Семейства верхнего уровня; уже привязанное (если оно глубже) тоже показываем
    familyOptions() {
      const list = this.$store.state.SchemeNodeElementsModule.listFamilies;
      const current = this.editedItem._family;
      return current && !list.some((f) => f.id === current.id)
        ? [{ id: current.id, name: current.name }, ...list]
        : list;
    },
    formTitle() {
      return this.editedItem.id ? "Редактирование элемента" : "Новый элемент";
    },
  },
  async mounted() {
    await this.$store.dispatch("SchemeNodeElementsModule/getListEntries");
    await this.$store.dispatch("SchemeNodeElementsModule/getListFamilies");
    // ?element=<id> — сразу открываем модалку этого элемента (ссылка из узла схемы)
    const idFromQuery = Number(this.$route.query.element);
    if (idFromQuery) {
      const item = this.$store.state.SchemeNodeElementsModule.listEntries.find(
        (el) => el.id === idFromQuery
      );
      if (item) {
        this.editItem(item);
        // ?focus=family — ссылка «заполните семейство»: курсор сразу в поле (после отрисовки модалки)
        if (this.$route.query.focus === "family") {
          setTimeout(() => this.$refs.family && this.$refs.family.focus(), 400);
        }
      } else this.setElementQuery(null);
    }
  },
  watch: {
    dialog(state) {
      if (!state) {
        this.editedItem = new SchemeNodeElement();
        this.iconError = "";
        this.setElementQuery(null);
      }
    },
  },
  methods: {
    addNewEntry() {
      this.editedItem = new SchemeNodeElement();
    },
    editItem(item) {
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
      this.setElementQuery(item.id);
    },
    // ?element=<id> отражает открытую модалку (можно поделиться ссылкой)
    setElementQuery(id) {
      // focus — служебный параметр ссылки «заполните семейство», живёт, пока открыта модалка
      const { element, focus, ...rest } = this.$route.query;
      if ((id || undefined) === (element ? Number(element) : undefined)) return;
      this.$router
        .replace({ query: id ? { ...rest, element: id } : rest })
        .catch(() => {});
    },
    // Загрузка иконки элемента: файл уходит в e_client_files (category=scheme-node-elements), к элементу
    // привязывается по «Сохранить» вместе с остальными полями; превью обновляется сразу
    async onIconSelected(event) {
      const input = event.target;
      const file = input.files && input.files[0];
      input.value = "";
      if (!file) return;

      this.iconError = "";
      if (!/\.svg$/i.test(file.name) && file.type !== "image/svg+xml") {
        this.iconError = "Нужен файл SVG";
        return;
      }

      this.iconUploading = true;
      try {
        const response = await this.$store.dispatch(
          "uploadFileGeneral",
          { uuid: crypto.randomUUID(), file, category: "scheme-node-elements" },
          { root: true }
        );
        if (!response || response.isError || !response.data) {
          this.iconError = "Не удалось загрузить файл";
          return;
        }
        this.$set(this.editedItem, "id_file", response.data.id);
        this.$set(this.editedItem, "_file", response.data);
      } catch (e) {
        console.log(e);
        this.iconError = "Не удалось загрузить файл";
      } finally {
        this.iconUploading = false;
      }
    },
    deleteItem(item) {
      this.editedItem = item;
      this.dialogDelete = true;
    },
    async saveEntry() {
      const response = await this.$store.dispatch(
        "SchemeNodeElementsModule/onSubmit",
        this.editedItem
      );
      if (response && !response.isError) this.dialog = false;
    },
    async deleteEntryConfirmed() {
      await this.$store.dispatch(
        "SchemeNodeElementsModule/deleteEntry",
        this.editedItem.id
      );
      this.dialogDelete = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.scheme_node_elements {
  &__header {
    font-size: 1em;
  }
  &__table {
    ::v-deep tbody tr {
      cursor: pointer;
    }
    // заголовки в одну строку: иначе у узкой колонки значок сортировки уходит на вторую строку
    // и поднимает текст заголовка относительно соседних
    ::v-deep thead th {
      white-space: nowrap;
    }
  }
  &__modal_item {
    display: grid;
    gap: 22px;
    padding-top: 1.5em !important;
    padding-bottom: 1em !important;
  }
  &__icon_block {
    display: grid;
    gap: 12px;
  }
  &__preview {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 180px;
    background: repeating-conic-gradient(#f4f4f4 0% 25%, #fff 0% 50%) 0 0 / 20px 20px;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 8px;
    img {
      max-width: 80%;
      max-height: 80%;
      object-fit: contain;
    }
  }
  &__icon {
    width: 28px;
    height: 28px;
    object-fit: contain;
    display: block;
  }
}
</style>
